<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-table-presupuesto"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import { cellRendererActivoInactivo, cellRendererNumeroRegistro } from '../utils';
import ListadoAgGridMixin from './../mixins/listado-ag-grid-mixin';

export default {
  mixins: [ListadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'NRO. REG.',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'FECHA',
          field: 'created_at',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'GESTION',
          field: 'gestion.numero',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'NOMBRE',
          field: 'nombre',
          filter: false,
          minWidth: 400,
        },
        {
          headerName: 'ESTADO',
          filter: false,
          cellRenderer: cellRendererActivoInactivo,
          minWidth: 100,
          maxWidth: 100,
        },
      ],
    };
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';
.ag-grid-table-presupuesto {
  height: calc(var(--vh, 1vh) * 100 - 17rem);
}
</style>
  